import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { useLang } from './LanguageContext';
import t from './translations';
import './Footer.css';

const Footer = () => {
  const { lang } = useLang();
  const { footer } = t[lang];

  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="mailto:balani.aakash@gmail.com" aria-label="Email">
          <FontAwesomeIcon icon={faEnvelope} />
        </a>
        <a href="https://www.linkedin.com/in/balaniakash" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FontAwesomeIcon icon={faLinkedin} />
        </a>
        <a href="https://github.com/AkashBalani" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <FontAwesomeIcon icon={faGithub} />
        </a>
      </div>
      <p className="footer-text">{footer.copyright}</p>
    </footer>
  );
};

export default Footer;
